import React, { useState } from "react";

const BALLS_BASE = `${import.meta.env.BASE_URL}img/superOver/balls`;

// Reference Ball component: "ASS" -> A, "10SS" -> 10 (3 chars -> 1, 4 chars -> 2); "1" -> no image
const ballValue = (token) => (token.length === 3 ? token.slice(0, 1) : token.length === 4 ? token.slice(0, 2) : null);

/**
 * Video overlay of casino/superover3 (Mini SuperOver), reference markup:
 *   .casino-video-cards(.hide-cards) > .casino-cards-shuffle + .casino-video-cards-container > 4 x div > span(s)
 * t1.card holds 4 balls separated by "|" (each may hold several cards joined by ","), shown as
 * superOver/balls/{value}.png. The shuffle button toggles the cards (not while the first ball is still "1").
 */
export default function SuperOver3CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (!card) return null;
  const cards = String(card).split("|");
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i}>
            {String(cards[i] ?? "")
              .split(",")
              .map((token, j) => {
                const v = ballValue(token.trim());
                return <span key={j}>{v && <img src={`${BALLS_BASE}/${v}.png`} alt="" />}</span>;
              })}
          </div>
        ))}
      </div>
    </div>
  );
}
